<template>
  <div data-qa="confirmsavemandates-div-hu3ses">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="confirmsavemandates-overlay-mmbanl">
      <v-progress-circular :color="primaryColor" :size="70" :width="7" indeterminate class="circular-loader" data-qa="confirmsavemandates-progress-circular-943zba">
      </v-progress-circular>
    </v-overlay>
    <Modal
      v-if="config.showConfimModal"
      :config="{...modalConfig.confirmSaveMandates, title:modalTitle,
                body: confirmSaveMandatesBody}"
      @btn1Action="routeToAccountMandates()"
      @btn2Action="routeToDashboard()">
        <span slot='modalContent' class='font-weight-medium'
            style="display: block; margin-bottom: 30px;"
            v-if="config.action === 'fail' && errors" data-qa="confirmsavemandates-span-h3npjl">
          {{ $t("accountMandates.info.saveFailInfo") }}
        </span>
        <span slot='modalContent' class='font-weight-medium red--text'
          style="display: block;"
          v-show="config.action === 'fail' && errors && errors.length"
          v-for="(item, i) in errors" :key="item.code" :data-qa="`confirmsavemandates-span-3ygydw-${i}`">
          {{ item.message }}
        </span>
        <span slot='modalContent' class='font-weight-medium "red--text'
              v-if="config.action === 'fail' && !errors" data-qa="confirmsavemandates-span-3ygydw">
          {{ $t("accountMandates.errorMsg.apiReqFail") }}
        </span>
    </Modal>
  </div>
</template>

<script>
import event from '@/util/event'
import Modal from '@/components/common/Modal.vue'

export default {
  name: 'ConfirmSaveMandates',
  components: {
    Modal
  },
  balance: 0,
  props: {
    config: Object
  },
  data () {
    return {
      modalConfig: {
        confirmSaveMandates: {
          enabled: true,
          persistent: true,
          btn1Label: this.$t('accountMandates.button.viewMandates'),
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 650
        }
      },
      errors: []
    }
  },
  created () {
    this.loaderEnabled = !this.config.showConfimModal
    if (this.config.causes) {
      this.getCauses()
    }
    event.$emit('closeSavingsAccountSanity', false)
  },
  updated () {
    this.loaderEnabled = !this.config.showConfimModal
    if (this.config.causes) {
      this.getCauses()
    }
  },
  computed: {
    modalTitle () {
      return this.config.action === 'success'
        ? this.$t('accountMandates.info.defnUpdate')
        : this.$t('accountMandates.errorMsg.saveFailed')
    },
    confirmSaveMandatesBody () {
      return this.config.action === 'success' ? this.$t('accountMandates.subtitle') : ''
    }
  },
  methods: {
    routeToDashboard () {
      setTimeout(() => {
        this.$router.push({
          path: '/home'
        })
      }, 600)
    },
    routeToAccountMandates () {
      setTimeout(() => {
        this.config.showConfimModal = false
      }, 600)
    },
    getCauses () {
      const status = this.config.status
      switch (status) {
        case 500:
          this.errors = ''
          break
        case 400:
          this.errors = this.config.causes
          break
        default:
          this.errors = this.config.causes
          break
      }
    },
    getIcon (action) {
      if (action === 'success') {
        return this.getSvgIconSrc('Success')
      }
      if (action === 'fail') {
        return this.getSvgIconSrc('Error')
      }
    }
  }
}
</script>
